export enum GtmEventCategory {
  Click = 'gtm.click',
}

export enum GtmClickEventList {
  Newsletter = 'inscription-newsletter-part',
}
